import { bootstrapScenes } from '@components/MediaSlot/sceneRuntime';

bootstrapScenes();
